function getTimeRemaining(endtime) {
  var now = new Date(); // Get current time in local time zone
  var t = Date.parse(endtime) - now.getTime(); // Use `getTime` for consistency

  var seconds = Math.floor((t / 1000) % 60);
  var minutes = Math.floor((t / 1000 / 60) % 60);
  var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
  var days = Math.floor(t / (1000 * 60 * 60 * 24));

  return {
    total: t,
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
}

function initializeClock(clockDiv, endtime) {
  var daysSpan = clockDiv.querySelector('.days');
  var hoursSpan = clockDiv.querySelector('.hours');
  var minutesSpan = clockDiv.querySelector('.minutes');
  var secondsSpan = clockDiv.querySelector('.seconds');

  function updateClock() {
    var t = getTimeRemaining(endtime);

    // Update the HTML elements with the remaining time
    daysSpan.innerHTML = ('0' + t.days).slice(-2);
    hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
    minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
    secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);

    // When time is up, hide the clock
    if (t.total <= 0) {
      clearInterval(timeinterval);
      clockDiv.style.display = "none";
    }
  }

  // Call updateClock immediately to set the initial values
  updateClock();
  var timeinterval = setInterval(updateClock, 1000);
}

document.addEventListener("DOMContentLoaded", function () {
  var clocks = document.querySelectorAll('.clockdiv');
  var deadlineKey = 'clock-deadline';

  // Dynamically fetch or define the latest target date
   var updatedTargetDate = new Date(2025, 5, 30, 23, 59, 59);

  // Check if the stored deadline is outdated
  var storedDeadline = localStorage.getItem(deadlineKey);

  clocks.forEach(function (clock) {
    if (clock.closest('.os-timer-time')) {
      var deadline;

      if (storedDeadline) {
        deadline = new Date(storedDeadline);

        // Update the stored deadline if it differs from the updated target date
        if (Date.parse(updatedTargetDate) !== Date.parse(deadline)) {
          deadline = updatedTargetDate;
          localStorage.setItem(deadlineKey, deadline.toISOString());
        }
      } else {
        // No stored deadline; use the updated target date
        deadline = updatedTargetDate;
        localStorage.setItem(deadlineKey, deadline.toISOString());
      }

      // Initialize the clock with the latest deadline
      initializeClock(clock, deadline);
    }
  });

  // Optional: Allow manual resetting of the deadline
  document.querySelector('.reset-clock')?.addEventListener('click', function () {
    localStorage.removeItem(deadlineKey);
    window.location.reload(); // Refresh to apply the new timer
  });
});
